import { Address } from '@/shared/models/Address';

interface MapObject {
  type: string;
  target: string;
}

export class GoogleMapAddressService {
  public static ADDRESS_COMPONENTS: Record<string, MapObject> = {
    street_number: {
      type: 'short_name',
      target: 'streetNumber',
    },
    premise: {
      type: 'short_name',
      target: 'streetNumber',
    },
    route: {
      type: 'long_name',
      target: 'street',
    },
    sublocality_level_1: {
      type: 'long_name',
      target: 'city',
    },
    administrative_area_level_2: {
      type: 'long_name',
      target: 'city',
    },
    // administrative_area_level_1: {
    //   type: 'long_name',
    //   target: 'city',
    // },
    locality: {
      type: 'long_name',
      target: 'city',
    },
    country: {
      type: 'short_name',
      target: 'countryCode',
    },
    postal_code: {
      type: 'short_name',
      target: 'zip',
    },
  };

  public static getAddress(place: google.maps.GeocoderResult | google.maps.places.PlaceResult): Address {
    const address = {
      latitude: 0,
      longitude: 0,
      street: '',
      streetNumber: '',
      city: '',
      countryCode: '',
      zip: '',
    } as Address;

    if (place) {
      if (place.address_components) {
        for (let i = 0; i < place.address_components.length; i++) {
          const addressType = place.address_components[i].types[0];
          const addressMap = this.ADDRESS_COMPONENTS[addressType];

          if (addressMap) {
            const val = (place.address_components[i] as any)[addressMap.type];
            if (!address[addressMap.target]) {
              address[addressMap.target] = val;
            }
          }
        }
      }
      if (place.geometry) {
        address.latitude = place.geometry.location.lat();
        address.longitude = place.geometry.location.lng();
      }
    }

    if (!address.street && address.streetNumber) {
      address.street = address.city;
    }

    const parts: string[] = [];
    parts.push((address.street + ' ' + address.streetNumber).trim());
    parts.push((address.zip + ' ' + address.city).trim());

    address.address = parts.filter((x) => x.length > 0).join(', ');

    return address;
  }
}
